<template>
  <div class="wrong_question">
    <div class="wrong_one my-20" v-for="(item, index) in wrongQuestionList" :key="index">
      <!-- <div class="wrong_one_top flex Flexalign FlexBetween">
        <div class="flex Flexalign">
          <el-image class="select_play cursor_pointer" :src="imgPath('select_play.png')" v-if="item.isExpend"
            @click="changeIsExpend(item)"></el-image>
          <el-image class="select_play selected_play cursor_pointer" :src="imgPath('select_play.png')" v-else
            @click="changeIsExpend(item)"></el-image>
          <div class="mar_left_15">
            <span>课程名称：</span>
            <span class="text_active">《{{ item.courseName }}》</span>
          </div>
        </div>
        <div></div>
      </div> -->
      <div v-if="item.isExpend">
        <choice v-if="item.questionTypeId == 1 || item.questionTypeId == 9" :questionInfo="item"></choice>
        <multipleChoice v-else-if="item.questionTypeId == 2" :questionInfo="item"></multipleChoice>
        <trueOrFalse v-else-if="item.questionTypeId == 4 || item.questionTypeId == 11" :questionInfo="item"></trueOrFalse>
        <sort v-else-if="item.questionTypeId == 6 || item.questionTypeId == 15" :questionInfo="item"></sort>
        <fillIn v-else-if="item.questionTypeId == 3 || item.questionTypeId == 14" :questionInfo="item"></fillIn>
        <informationMatch v-else-if="item.questionTypeId == 32" :questionInfo="item"></informationMatch>
        <textAnswer v-else-if="item.questionTypeId == 13 || item.questionTypeId == 7 || item.questionTypeId == 16 || item.questionTypeId == 17" :questionInfo="item"></textAnswer>
        <comprehensiveAnswer v-else-if="item.questionTypeId == 99 || item.questionTypeId == 101 || item.questionTypeId == 102 || item.questionTypeId == 103" :questionInfo="item"></comprehensiveAnswer>
        <moe-empty url="development_icon.png" emptyText="更多题型开发中" v-else></moe-empty>
      </div>
    </div>
  </div>
</template>

<script>
import choice from "@/components/wrongQuestion/choice.vue";
import multipleChoice from '@/components/wrongQuestion/multipleChoice.vue';
import trueOrFalse from '@/components/wrongQuestion/trueOrFalse.vue';
import sort from "@/components/wrongQuestion/sort.vue";
import fillIn from "@/components/wrongQuestion/fillIn.vue";
import textAnswer from "@/components/wrongQuestion/textAnswer.vue";
import comprehensiveAnswer from "@/components/wrongQuestion/comprehensiveAnswer.vue";
import informationMatch from '@/components/wrongQuestion/informationMatch.vue';
export default {
  name: "GjkcH5WrongQuestionList",
  components: {
    choice,
    multipleChoice,
    trueOrFalse,
    sort,
    fillIn,
    textAnswer,
    comprehensiveAnswer,
    informationMatch
  },

  data() {
    return {
      wrongQuestionList: [],
    };
  },

  mounted() { },

  methods: {
    changeIsExpend(info) {
      info.isExpend = !info.isExpend;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrong_question {
  width: 100%;

  .wrong_one {
    .wrong_one_top {
      color: #666666;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .select_play {
        width: 24px;
        height: 24px;
        transition: 0.5s;
        rotate: -90deg;
      }

      .selected_play {
        rotate: 90deg;
      }
    }
  }
}
</style>
